import { render, staticRenderFns } from "./bigpartPriority.vue?vue&type=template&id=70197454&scoped=true&"
import script from "./bigpartPriority.vue?vue&type=script&lang=js&"
export * from "./bigpartPriority.vue?vue&type=script&lang=js&"
import style0 from "./bigpartPriority.vue?vue&type=style&index=0&id=70197454&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70197454",
  null
  
)

export default component.exports